// No confirmation prompt here by design: this button only posts a message across the native
// bridge, and the app shows its own confirmation dialog on receiving it before deleting the
// account. Never rendered on the web.

import React from "react";
import { Button } from "react-bootstrap";
import { isEmbeddedApp, notifyNativeDeleteAccount } from "utils/embeddedApp";

type DeleteAccountButtonProps = {
  "data-test-id"?: string;
};

const DeleteAccountButton: React.FC<DeleteAccountButtonProps> = ({ "data-test-id": testId }) => {
  if (!isEmbeddedApp()) {
    return null;
  }

  return (
    <Button data-test-id={testId} variant="danger" className="w-100 mt-4" onClick={notifyNativeDeleteAccount}>
      Delete Account
    </Button>
  );
};

export { DeleteAccountButton };
